import initialState from './initialState';
import { LoadingStatusEnum } from '../../../constants/enums';

export const GetFactoryFilesReducer = {
  pending: (state) => ({
    ...state,
    loading: LoadingStatusEnum.Pending,
  }),
  fulfilled: (state, action) => ({
    ...state,
    factoryFileList: action.payload.data,
    loading: LoadingStatusEnum.Succeeded,
  }),
  rejected: (state) => ({
    ...state,
    loading: LoadingStatusEnum.Failed,
  }),
};

export const ClearFactoryFilesReducer = () => initialState;
